import PhoneNumber from 'awesome-phonenumber';

export const formatPhone = (number) => {
  const phone = new PhoneNumber(number);
  const nationalNumber = phone ? phone.getNumber('national') : '';
  const internationalNumber = phone && nationalNumber ? `+${phone.getCountryCode()} ${nationalNumber}` : '';
  return internationalNumber;
};
